import { AuthBaseClient } from '../base-client';
import type {
  RoleResponse,
  RoleWithPermissions,
  PermissionsListResponse,
  CreateRoleRequest,
  UpdateRoleRequest,
} from './types';

/**
 * Client for role management API endpoints.
 */
export class RoleClient extends AuthBaseClient {
  /**
   * List all roles for the organization.
   */
  async list(): Promise<RoleResponse[]> {
    return this.get<RoleResponse[]>('/api/roles');
  }

  /**
   * Get role by ID with permissions.
   */
  async getById(id: string): Promise<RoleWithPermissions> {
    return this.get<RoleWithPermissions>(`/api/roles/${id}`);
  }

  /**
   * Get all available permissions (for role editor UI).
   */
  async getPermissions(): Promise<PermissionsListResponse> {
    return this.get<PermissionsListResponse>('/api/roles/permissions');
  }

  /**
   * Create a new custom role.
   */
  async create(data: CreateRoleRequest): Promise<RoleResponse> {
    return this.post<RoleResponse>('/api/roles', data);
  }

  /**
   * Update a role.
   */
  async update(id: string, data: UpdateRoleRequest): Promise<RoleResponse> {
    return this.patch<RoleResponse>(`/api/roles/${id}`, data);
  }

  /**
   * Toggle role active/inactive status.
   */
  async toggleStatus(id: string): Promise<RoleResponse> {
    return this.patch<RoleResponse>(`/api/roles/${id}/toggle`, {});
  }
}
